/**
 * @voltxampere/ui — DIAC DB3 variant (Sprint 44-2, placeholder)
 *
 * PLACEHOLDER. Bidirectional trigger diode (symmetric breakdown);
 * gerçek DIAC stamp (bidirectional zener-like breakdown branch
 * +/-V_BO) Sprint 47+ engine extension #4 ile aktif. Şu anki
 * stamp'te `zener` schemaType üzerinden tek-yön breakdown
 * davranış gösterir.
 *
 * Reference: NXP DB3 — DO-35. V_BO = ±32 V (typ., breakover
 * voltage), I_BO = 200 µA (breakover current), V_O = 5 V (output
 * voltage at I = 100 mA). TRIAC tetikleme + dimmer + flash kontrol
 * uygulamaları için yaygın.
 *
 * Engine zero-diff invariant honored — canonical `zener` engine
 * type via schemaType. breakdownVoltage = 32 V; gerçek
 * bidirectional davranış Sprint 47+'da iki-yönlü zener stamp ile
 * aktif olur.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { zener } from "../zener.js";
export const powerDiacDb3 = {
    id: "db3",
    nameTr: "DB3 (DIAC ±32V, DO-35, placeholder)",
    nameEn: "DB3 (DIAC ±32V, DO-35, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: zener.viewBox,
    terminals: zener.terminals,
    defaultLabel: "D",
    defaultValue: "DB3",
    schemaType: "zener",
    defaultParams: { saturationCurrent: 1e-12, ideality: 1.5, breakdownVoltage: 32 },
    renderSVG: () => zener.renderSVG(),
};
//# sourceMappingURL=power-diac-db3.js.map